import styled from 'styled-components'
import Button from 'antd/lib/button'
import icon from 'antd/lib/icon'
import Drawer from 'antd/lib/drawer'
import { catalogLocalVars } from '../catalogTheme'

export const FilterDrawer = styled(Drawer)`
  top: unset;
  bottom: 0;
  &.catalog-drawer-desktop {
    .ant-drawer-content-wrapper {
      width: var(--catalog-drawer-width) !important;
      max-width: 100vw;
    }
  }

  &.catalog-drawer-mobile {
    .ant-drawer-content-wrapper {
      width: 100% !important;
      max-width: 100vw;
      max-height: 100vh;
      height: auto !important;
    }

    .ant-drawer-mask {
      opacity: 1;
    }
  }

  .ant-drawer-body {
    padding: 0;
    display: flex;
    height: 100%;
    flex-direction: column;
    background: var(--neutral-white);
  }
`

export const DrawerShell = styled.div`
  ${catalogLocalVars}
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  #drawer-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 0 var(--spacing-16);
  }
  @media (max-width: 768px) {
    #drawer-body {
      overscroll-behavior: contain;
      touch-action: pan-y;
      -webkit-overflow-scrolling: touch;
      max-height: 548px;
    }
  }
`

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-24) var(--spacing-16);
  border-bottom: var(--border-regular) solid var(--neutral-border-med);

  h2 {
    margin: 0;
    font: 600 24px/30px var(--font-barlow-semi-condensed);
    letter-spacing: 0.44px;
    color: var(--neutral-darkest);
  }
`

export const DrawerIcon = styled(icon)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  background: transparent;
  font: 16px/1 var(--font-inter);
  color: var(--neutral-darkest);
  cursor: pointer;
`

export const DrawerFooter = styled.div`
  flex-shrink: 0;
  display: flex;
  gap: var(--spacing-20);
  align-items: flex-start;
  justify-content: center;
  padding: var(--spacing-24) var(--spacing-16);
  background: var(--neutral-lightest-block);
  border-top: var(--border-regular) solid var(--neutral-border-med);
`

export const ClearFiltersButton = styled(Button)`
  height: 42px;
  padding: var(--spacing-8) var(--spacing-16);
  border: var(--border-regular) solid var(--neutral-muted);
  border-radius: 0;
  background: var(--neutral-white);
  box-shadow: none;
  font: 600 12px/18px var(--font-barlow);
  letter-spacing: 1.12px;
  text-transform: uppercase;
  color: var(--neutral-body);

  &:hover,
  &:focus {
    color: var(--neutral-body);
    border-color: var(--neutral-muted);
    background: var(--neutral-white);
  }
`

export const ApplyButton = styled(Button)`
  height: 42px;
  width: 100%;
  padding: 7px var(--spacing-16);
  border: none;
  border-radius: 0;
  background: var(--neutral-darkest);
  box-shadow: none;
  font: 600 12px/18px var(--font-barlow);
  letter-spacing: 1.12px;
  text-transform: uppercase;
  color: var(--neutral-white);

  &:hover,
  &:focus {
    background: var(--neutral-darkest);
    color: var(--neutral-white);
  }
`

export const AccordionSection = styled.div<{ isLast?: boolean }>`
  border-bottom: ${({ isLast }) =>
    isLast ? 'unset' : `var(--border-regular) solid var(--neutral-border-med)`};

  .accordion-panel {
    padding-bottom: var(--spacing-24);
  }
`

export const AccordionTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--spacing-24) 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;

  .accordion-text {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .accordion-title {
    font: 600 20px/30px var(--font-barlow-semi-condensed);
    letter-spacing: 0.44px;
    color: var(--neutral-darkest);
  }

  .accordion-summary {
    font: 400 14px/22px var(--font-inter);
    color: var(--neutral-secondary);
  }
`

export const AccordionChevron = styled.span<{ expanded?: boolean }>`
  display: inline-flex;
  flex-shrink: 0;
  margin-left: var(--spacing-16);
  transition: transform 0.2s ease;
  transform: ${({ expanded }) => (expanded ? 'rotate(180deg)' : 'rotate(0deg)')};

  img {
    width: 14px;
    height: 7px;
  }
`

export const FilterCheckboxLabel = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--spacing-12);
  padding: var(--spacing-8) 0;
  cursor: pointer;

  .filter-checkbox-text {
    font: 400 14px/22px var(--font-inter);
    color: var(--neutral-darkest);
  }
`

export const FilterCheckboxInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`

export const FilterCheckboxBox = styled.span<{ checked?: boolean }>`
  flex-shrink: 0;
  width: var(--catalog-checkbox-size);
  height: var(--catalog-checkbox-size);
  border: 1.5px solid
    ${({ checked }) => (checked ? 'var(--neutral-darkest)' : 'var(--neutral-muted)')};
  border-radius: var(--catalog-checkbox-radius);
  background: ${({ checked }) =>
    checked ? 'var(--neutral-darkest)' : 'var(--neutral-white)'};
  transition: background 0.15s ease, border-color 0.15s ease;

  &::after {
    content: '';
    display: ${({ checked }) => (checked ? 'block' : 'none')};
    width: 4px;
    height: 8px;
    margin: 2px auto 0;
    border: solid var(--neutral-white);
    border-width: 0 1.5px 1.5px 0;
    transform: rotate(45deg);
  }
`

export const FilterRadioLabel = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--spacing-12);
  padding: var(--spacing-8) 0;
  cursor: pointer;
`

export const FilterRadioInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`

export const FilterRadioBox = styled.span<{ checked?: boolean }>`
  flex-shrink: 0;
  width: var(--catalog-checkbox-size);
  height: var(--catalog-checkbox-size);
  border: 1.5px solid
    ${({ checked }) => (checked ? 'var(--neutral-darkest)' : 'var(--neutral-muted)')};
  border-radius: 50%;
  background: var(--neutral-white);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s ease;

  &::after {
    content: '';
    display: ${({ checked }) => (checked ? 'block' : 'none')};
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--neutral-darkest);
  }
`

export const FilterRadioText = styled.span<{ checked?: boolean }>`
  font: 400 14px/22px var(--font-inter);
  color: ${({ checked }) =>
    checked ? 'var(--neutral-darkest)' : 'var(--neutral-secondary)'};
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ProductCatalogueV2/FilterSortDrawer/styledComponents.tsx